import { mapState, mapMutations } from 'vuex'

export const response = {
  created () {
    window.addEventListener('resize', this.setWindowWidth)
  },
  computed: {
    ...mapState('common', ['windowWidth'])
  },
  methods: {
    ...mapMutations('common', ['setWindowWidth'])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/response.js